import * as React from "react";
import { AppInfoContainer, AppTitle } from "./app-banner-style";
import { Icon } from "common/render/icon";
import type { IconImage } from "common/components/SerializedApp";
import type { RuntimeTheme } from "webapp/lib/theme/core-themes/runtime-theme";
import { withTheme } from "styled-components";

interface Props {
    readonly theme: RuntimeTheme;
    readonly title: string;
    readonly icon: IconImage;
}

class AppBannerImpl extends React.PureComponent<Props> {
    public render() {
        const { theme, title, icon } = this.props;
        return (
            <AppInfoContainer>
                <Icon color={theme.primaryAccentColor} image={icon} size={64} clipCorners={true} />
                <AppTitle>{title}</AppTitle>
            </AppInfoContainer>
        );
    }
}

const AppBanner = withTheme(AppBannerImpl);
export default AppBanner;
